import request from '../utils/request'; // 导入接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例
import qs from 'qs'

const SendMailAddress= {    
    // engcon    
    SendMailAddressInfor (opt) {        
        return axios.post(`${request.baseUrl1}SendMptSolutionMailAddressForVisitor`,qs.stringify(opt));    
    },  
    SaveForVisitorInfor (opt){
        return axios.post(`${request.baseUrl1}SaveMptSolutionContactUsForVisitor`,qs.stringify(opt));
    }
  
}

export default SendMailAddress;


// WEBPACK FOOTER //
// ./src/api/contactUs.js